// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"Avatar_Avatar__S6heX","AvatarInitial":"Avatar_AvatarInitial__lppqe"};